import styled from '@emotion/styled';

const Wrapper = styled.div`
  margin-top: 1rem;
  padding: 1.3rem 0;
  background: #e2e2e2;
  color: #bcbdbd;
  text-align: center;
  p {
    margin-bottom: 0;
  }
`;

export {
  Wrapper
};
